var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 18.6561C35.0021 21.426 34.1826 24.1343 32.6451 26.4382C31.1076 28.7421 28.9212 30.5382 26.3626 31.5992C23.804 32.6602 20.9881 32.9384 18.2714 32.3985C15.5547 31.8587 13.0591 30.5251 11.1005 28.5665C9.14192 26.6079 7.80833 24.1123 7.26848 21.3956C6.72864 18.6788 7.0068 15.863 8.06777 13.3044C9.12874 10.7458 10.9248 8.55942 13.2288 7.0219C15.5327 5.48439 18.241 4.66485 21.0108 4.667C24.7201 4.66987 28.2766 6.14465 30.8995 8.7675C33.5223 11.3903 34.9971 14.9469 35 18.6561Z",
    fill: "#ABCA57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3086 25.8682H25.0725",
    stroke: "#001698",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0725 25.8679H15.3086L21.3588 12.7402H41.9138L47.9753 25.8679H38.2001",
    stroke: "#001698",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2116 25.8682C38.1414 27.5619 37.4191 29.1629 36.1958 30.3365C34.9726 31.51 33.343 32.1654 31.6478 32.1654C29.9526 32.1654 28.323 31.51 27.0998 30.3365C25.8765 29.1629 25.1542 27.5619 25.084 25.8682",
    stroke: "#001698",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9753 25.8682V35.4853C47.9753 36.4163 47.6054 37.3092 46.9471 37.9676C46.2887 38.6259 45.3958 38.9958 44.4648 38.9958H18.8304C17.8983 38.9958 17.0042 38.6263 16.3441 37.9683C15.6839 37.3102 15.3116 36.4174 15.3086 35.4853V25.8682",
    stroke: "#001698",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.8c1c37c49381f6f9b14a69890fbba08f.svg";
export { ForwardRef as ReactComponent };